import React from 'react'

const ProposeSpecialIssue = () => {
  return (
    <div>
        <p>
        The journal welcomes proposals for Special Issues from legal scholars, research institutions, and professional organizations. Potential guest editors can submit a proposal for consideration, which must include: 
        </p>
        <h4 className="fw-bold text-blue font-size-21">Proposal Requirements </h4>
        <ul>
            <li><b>Title of the Special Issue</b> </li>
            <li><b>Description and Scope</b> (500-700 words explaining the significance of the topic) </li>
            <li><b>List of Potential Topics</b> (sub-themes that will be covered) </li>
            <li><b>Proposed Guest Editors</b> (Names, affiliations, and short bios) </li>
            <li><b>Target Audience</b> (Who will benefit from this issue?) </li>
            <li><b>Expected Number of Articles</b> </li>
            <li><b>Proposed Timeline</b> (Submission deadlines, review process, and publication schedule) </li>
        </ul>
        <br/>
        <h4 className="fw-bold text-blue font-size-21">Proposal Submission Process </h4>
        <ul>
            <li>Submit the proposal via the journal’s official email or online submission system.</li>  
            <li>The editorial board will review and evaluate the proposal based on relevance, academic merit, and feasibility. </li>  
     <li>Once approved, the journal will announce a Call for Papers for the Special Issue. </li>
        </ul> 

<p>
<b>Note:</b> Guest editors must ensure a <b>high-quality peer-review process</b> and adhere to the journal’s <b>ethical publication guidelines</b>. 
</p>


    </div>
  )
}

export default ProposeSpecialIssue